//import angular from 'angular';
import AdminUrls from '../../adminUrls';
import tmpl from './addEditKpi.html';



    angular.module('app.admin').component('addEditKpi', {
        bindings: {
            initParams: '=',
            buttonMethods: '=',
            buttonStates: '=',
            buttons: '=',
            closeOnSave: '=',
            wnd: '='
        },
        template: tmpl,
        controller: ['$scope', 'confirmSvc', 'enums', 'adminUrls', 'WindowFactory', 'ocSecuritySvc', 'amtCommandQuerySvc', 'notifySvc', 'amtXlatSvc', 'errorReporter',
            function ($scope, confirmSvc, enums, adminUrls: AdminUrls, WindowFactory: IWindowFactory, ocSecuritySvc, amtCommandQuerySvc, notifySvc, amtXlatSvc, errorReporter) {

                var vm = this;
                $scope.vm = this;

                vm.readonly = !ocSecuritySvc.isAuthorised('Security.Settings.SiteDetails.KPIs', 'readWrite');
                vm.urls = adminUrls;

                vm.showWarning = false;

                this.$onInit = function () {

                    if (vm.wnd !== null) {
                        vm.wnd.onClose = vm.cancel;
                    }

                    vm.data = angular.copy(vm.initParams);

                    if (!vm.data.id) {
                        vm.data.active = true; // default new kpi to active
                    }

                    vm.buttons = [
                        {
                            primary: true,
                            cancel: false,
                            value: "common.save_label",
                            name: "saveButton",
                            click: "save",
                            type: enums.buttonTypes.button
                        },
                        {
                            primary: false,
                            cancel: false,
                            value: "common.saveAndAddAnother_label",
                            name: "saveAndAddAnotherButton",
                            click: "saveAndAddAnother",
                            type: enums.buttonTypes.button
                        },
                        {
                            primary: false,
                            cancel: true,
                            value: "common.cancel_label",
                            name: "cancelButton",
                            click: "cancel",
                            type: enums.buttonTypes.button
                        }
                    ];

                    vm.buttonStates = {
                        saveButton: {
                            visible: !vm.readonly,
                            disabled: true
                        },
                        saveAndAddAnotherButton: {
                            visible: !vm.readonly,
                            disabled: true
                        },
                        cancelButton: {
                            visible: true,
                            disabled: false
                        }
                    };

                    vm.buttonMethods = {
                        save: vm.save,
                        saveAndAddAnother: vm.save,
                        cancel: vm.cancel
                    };
                }

                vm.save = function (button) {

                    var criteria = {
                        kpi: vm.data.kpi,
                        target: vm.data.target,
                        id: vm.data.id,
                        active: vm.data.active
                    };

                    vm.wnd.processing = true;

                    return amtCommandQuerySvc.post(vm.urls.saveSiteKpi, criteria).then(function (response) {

                        notifySvc.success(amtXlatSvc.xlat('siteDetails.siteKpiSavedSuccessfully'));

                        if (vm.wnd.onDataChanged) {
                            vm.wnd.onDataChanged();
                        }

                        if (button === 'saveAndAddAnother') {
                            // keep window open, clear data, update caption to add, default active to true, set pristine
                            vm.wnd.caption = amtXlatSvc.xlat('siteDetails.addKpi');
                            vm.data = {
                                active: true
                            };
                            vm.form.$setPristine();
                        } else {
                            vm.closeWindow();
                        }

                    }).catch(function (error) {
                        errorReporter.logError(error);
                    }).finally(function () {
                        vm.wnd.processing = false;
                    });
                };

                vm.closeWindow = function () {
                    WindowFactory.closeWindow(vm.wnd);
                };

                vm.cancel = function () {
                    confirmSvc.confirmSaveChange(vm.form.$dirty).then(function () {
                        vm.form.dirty = false;
                        vm.closeWindow();
                        return true;
                    });

                    return false;
                };

                $scope.$watchGroup(['vm.form.$invalid', 'vm.form.$pristine', 'vm.wnd.processing'], function () {
                    vm.buttonStates.saveButton.disabled = vm.form.$invalid || vm.form.$pristine || vm.wnd.processing;
                    vm.buttonStates.saveAndAddAnotherButton.disabled = vm.form.$invalid || vm.form.$pristine || vm.wnd.processing;
                });
            }
        ]
    });
